import { render, staticRenderFns } from "./grower-syndicate-splits.vue?vue&type=template&id=4bba0896"
import script from "./grower-syndicate-splits.vue?vue&type=script&lang=js"
export * from "./grower-syndicate-splits.vue?vue&type=script&lang=js"
import style0 from "./grower-syndicate-splits.vue?vue&type=style&index=0&id=4bba0896&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports